// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#00008d","primaryColorLight":"#00008d","spinner":"styles_spinner__H782g","withPadding":"styles_withPadding__kQ19E"};